import { render, staticRenderFns } from "./bigbrand.vue?vue&type=template&id=559bf7c0&"
import script from "./bigbrand.vue?vue&type=script&lang=js&"
export * from "./bigbrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports